var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.94,
    height: 16,
    viewBox: "0 0 15.94 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-telephone",
    "data-name": "001-telephone",
    transform: "translate(-0.912 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M4.142,10.636a16.974,16.974,0,0,0,5.646,4.423,8.787,8.787,0,0,0,3.16.935c.076,0,.149.007.225.007a2.616,2.616,0,0,0,2.029-.872.072.072,0,0,0,.013-.017,8.543,8.543,0,0,1,.64-.663c.156-.149.315-.305.467-.464a1.6,1.6,0,0,0-.007-2.384L14.323,9.608a1.613,1.613,0,0,0-1.167-.537,1.667,1.667,0,0,0-1.18.534l-1.187,1.187c-.109-.063-.222-.119-.328-.172a4.1,4.1,0,0,1-.365-.2,12.561,12.561,0,0,1-3-2.732A7.234,7.234,0,0,1,6.081,6.07c.312-.282.6-.577.885-.865.1-.1.2-.206.305-.308A1.7,1.7,0,0,0,7.822,3.7a1.686,1.686,0,0,0-.55-1.194l-.988-.988c-.116-.116-.225-.229-.338-.345C5.726.951,5.5.719,5.272.511A1.653,1.653,0,0,0,4.105,0a1.7,1.7,0,0,0-1.18.514l-1.24,1.24A2.548,2.548,0,0,0,.926,3.385a6.136,6.136,0,0,0,.461,2.652A15.43,15.43,0,0,0,4.142,10.636ZM1.735,3.455a1.754,1.754,0,0,1,.527-1.127L3.5,1.094a.893.893,0,0,1,.61-.282.847.847,0,0,1,.6.288c.222.206.431.421.656.65.113.116.229.232.345.351l.988.988A.9.9,0,0,1,7,3.71a.9.9,0,0,1-.312.62c-.1.1-.206.209-.308.312-.308.312-.6.607-.915.889l-.017.017a.648.648,0,0,0-.166.736c0,.01.007.017.01.027A7.8,7.8,0,0,0,6.459,8.2a13.258,13.258,0,0,0,3.2,2.911,4.746,4.746,0,0,0,.438.239,4.1,4.1,0,0,1,.365.2l.036.02a.693.693,0,0,0,.322.083.7.7,0,0,0,.494-.225l1.24-1.24a.877.877,0,0,1,.607-.3.833.833,0,0,1,.587.3l2,2a.8.8,0,0,1-.01,1.25c-.139.149-.285.292-.441.441a9.548,9.548,0,0,0-.693.719,1.82,1.82,0,0,1-1.422.6c-.056,0-.116,0-.172-.007a7.983,7.983,0,0,1-2.858-.855,16.126,16.126,0,0,1-5.374-4.211,14.769,14.769,0,0,1-2.619-4.36A5.347,5.347,0,0,1,1.735,3.455Z",
    fill: "#356bb0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bbf121016d667e3afcdbf0e5bfed6ae2.svg";
export { ForwardRef as ReactComponent };